/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scale common lab buffer recipes (TBS, PBS, blocking buffers) to any volume.`)
};

const es_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escala recetas comunes de buffers de laboratorio (TBS, PBS, buffers de bloqueo) a cualquier volumen.`)
};

const de_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skalieren Sie gängige Laborpuffer-Rezepte (TBS, PBS, Blockierpuffer) auf jedes Volumen.`)
};

const nl_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schaal veelgebruikte labbuffer-recepten (TBS, PBS, blokkeerbuffers) naar elk volume.`)
};

const fr_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptez les recettes de tampons de laboratoire courants (TBS, PBS, tampons de blocage) à n'importe quel volume.`)
};

const it_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scala le ricette comuni dei buffer di laboratorio (TBS, PBS, buffer di blocco) a qualsiasi volume.`)
};

const pt_br2_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione receitas comuns de tampões de laboratório (TBS, PBS, tampões de bloqueio) para qualquer volume.`)
};

const pt_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escale receitas comuns de tampões de laboratório (TBS, PBS, tampões de bloqueio) para qualquer volume.`)
};

const ja_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBS、PBS、ブロッキングバッファーなど一般的な実験バッファーのレシピを任意の量にスケーリングします。`)
};

const zh_buf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将常见实验室缓冲液配方（TBS、PBS、封闭液）按任意体积放大。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_tool_description", locale)
	if (locale === "en") return en_buf_tool_description(inputs)
	if (locale === "es") return es_buf_tool_description(inputs)
	if (locale === "de") return de_buf_tool_description(inputs)
	if (locale === "nl") return nl_buf_tool_description(inputs)
	if (locale === "fr") return fr_buf_tool_description(inputs)
	if (locale === "it") return it_buf_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_buf_tool_description(inputs)
	if (locale === "pt") return pt_buf_tool_description(inputs)
	if (locale === "ja") return ja_buf_tool_description(inputs)
	return zh_buf_tool_description(inputs)
};